import { SortOrderType } from '@repo/common';

import { UrlSearchFilterProperty } from '@/constants';
import { useGetAllOrdersV2Query } from '@/features/slice/order';
import { useUrlFilter, useUrlPagination } from '@/hooks';

import { mapDateObjectToString } from '../../../utils/mappers/map-date-object-to-string.mapper';
import {
    CUSTOMER_ID_FILTER_KEY,
    CUSTOMER_TYPE_FILTER_KEY,
    PAYMENT_STATUS_FILTER_KEY,
    USER_ID_FILTER_KEY,
} from './constant';

type UseOrderListProps = {
    customerId?: string;
};

export const useOrderList = ({ customerId: cid }: UseOrderListProps = {}) => {
    const { limit, page, setCurrentPage } = useUrlPagination();
    const { sortBy, sortOrder, debouncedSearchText, getSearchFilter } =
        useUrlFilter({
            defaultSortBy: 'created_at',
            defaultSortOrder: SortOrderType.DESC,
        });

    const customerType = getSearchFilter(CUSTOMER_TYPE_FILTER_KEY) || undefined;
    const paymentStatus =
        getSearchFilter(PAYMENT_STATUS_FILTER_KEY) || undefined;
    const customerId =
        cid || getSearchFilter(CUSTOMER_ID_FILTER_KEY) || undefined;
    const userId = getSearchFilter(USER_ID_FILTER_KEY) || undefined;

    const fromDate =
        getSearchFilter(UrlSearchFilterProperty.DATE_FROM) || undefined;
    const toDate =
        getSearchFilter(UrlSearchFilterProperty.DATE_TO) || undefined;

    const queryParams: Record<string, string | number> = {
        limit,
        page,
        sort_by: sortBy,
        sort_order: sortOrder,
    };

    if (debouncedSearchText) {
        queryParams['search'] = debouncedSearchText;
    }

    if (debouncedSearchText) {
        queryParams['search'] = debouncedSearchText;
    }
    if (customerType) {
        queryParams['customer_type'] = customerType;
    }
    if (paymentStatus) {
        queryParams['status'] = paymentStatus;
    }
    if (customerId) {
        queryParams['customer_id'] = customerId;
    }
    if (userId) {
        queryParams['user_id'] = userId;
    }

    if (fromDate) {
        const dateObj = new Date(fromDate);
        // const isoString = dateObj.toISOString();
        queryParams['start_date'] = mapDateObjectToString(dateObj);
    }
    if (toDate) {
        const dateObj = new Date(toDate);
        // const isoString = dateObj.toISOString();
        queryParams['end_date'] = mapDateObjectToString(dateObj);
    }

    const { isError, isFetching, isSuccess, data, isLoading } =
        useGetAllOrdersV2Query(queryParams);

    return {
        isError,
        isFetching,
        isSuccess,
        data,
        isLoading: isLoading || isFetching,
        setCurrentPage,
        page,
    };
};
